import { formatMkd } from '../lib/format';

export interface Category {
  id: number;
  kategoria: string;
  total: number;
}

/**
 * The clickable category tiles above an expense grid, shared by Shpenzimet
 * Aktuale and Planifikuara.
 *
 * The desktop forms had eight fixed Label controls and assigned categories
 * into them positionally, so Starbar and Stargroup — which have fourteen —
 * silently lost six. This renders whatever the server returns.
 */
export default function CategoryTiles({
  categories,
  loading,
  selectedId,
  onSelect,
}: {
  categories: Category[];
  loading: boolean;
  selectedId: number | null;
  onSelect: (id: number) => void;
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="h-20 animate-pulse rounded-xl bg-white" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
      {categories.map((c) => {
        const active = c.id === selectedId;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onSelect(c.id)}
            aria-pressed={active}
            className={`rounded-xl border p-3 text-left transition-all ${
              active
                ? 'border-brand-500 bg-white ring-2 ring-brand-100'
                : 'border-slate-200 bg-white hover:border-slate-300'
            }`}
          >
            <div className="line-clamp-2 text-xs font-medium text-muted" title={c.kategoria}>
              {c.kategoria}
            </div>
            <div
              className={`tnum mt-1 text-lg font-semibold ${active ? 'text-brand-600' : 'text-ink'}`}
            >
              {formatMkd(c.total)}
            </div>
          </button>
        );
      })}
    </div>
  );
}
